module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch5"
    }
  }), _vm._v("DON LUÍS’S REVENGE, 1570")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("E")]), _vm._v("ven from Columbus’s time, Spain had its eye on North America. In 1561, a Spanish expedition arrived in the Chesapeake Bay and took away with them Paquiquino, son of a local native chieftain. In the decade he remained with Spaniards, he was converted to Christianity and became fluent in Spanish. He became the ward of the governor of Mexico and took the official’s name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In September 1570, Jesuit priests on a mission to convert Native Americans landed not far from the future site of the Jamestown settlement. They were guided by Paquiquino, now newly renamed Don Luis. Soon, the boy was reunited with his family, and he reverted to his native roots with all its intense hostility to European “invaders.” He broke with the Jesuits. Later in the winter, the starving priests reached out to the American Indians. During negotiations, Don Luis led a raiding party that killed all the priests. With the collapse of this colony, Spain never again attempted to settle Chesapeake Bay. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(12-004)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img13.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac40126","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter005.vue
// module id = 90
// module chunks = 0